<template lang="html">
  <div>
    <v-form
      class="overflow"
      data-simplebar
    >
      <v-container>
        <v-alert
          :value="existed"
          color="indigo"
          icon="info"
          transition="scale-transition"
        >
          <v-row>
            <v-col 
              class="white--text"
              cols="10"
            >
              Are you trying to configure account for <span class="title">{{ existedPerson.name }}</span>?
            </v-col>
            <v-col cols="1">       
              <v-btn
                small
                rounded
                color="error"
                @click="existed = false;checkIc = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn
                :loading="progressing"
                small
                rounded
                dark
                color="green"
                @click="hasEmployee"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-alert
          v-if="citizenshipLookupObject && citizenshipLookupObject.value==systemBasedCountry"
          :value="!checkIc"
          type="info"
          color="primary"
          transition="scale-transition"
        >
          Please key in the IC number
        </v-alert>
        <v-alert
          :value="contactAdmin"
          type="error"
          dismissible
          icon="warning"
          transition="scale-transition"
        >
          Failed to create. Please contact administator for further assistance
        </v-alert>
        <v-alert
          v-if="citizenshipLookupObject && citizenshipLookupObject.value==systemBasedCountry"
          :value="newPerson"
          type="success"
          dismissible
          transition="scale-transition"
        >
          You may create new account with this IC
        </v-alert>
        <v-alert
          :value="personWithoutEmployee()"
          type="info"
          dismissible
          color="primary"
          transition="scale-transition"
        >
          Please fill the remaining active fields below
        </v-alert>

        <v-row
          class="dense-row"
        >
          <v-col 
            cols="12" 
            class="py-0"
            md="6"
          >
            <v-autocomplete
              v-model="citizenshipLookupObject"
              :error-messages="errors.collect('citizenshipLookupUid')"
              :items="citizenship"
              data-vv-name="citizenshipLookupUid"
              data-vv-as="citizenshipLookupUid"
              :item-text="item => '['+item.value+'] ' + item.description1"
              item-value="id"
              label="Citizenship"
              return-object
              :disabled="isDraftEmpDisabled"
              :filled="isDraftEmpDisabled"
              @input="citizenshipChange(citizenship.find(citizen => {return citizen.lookup_uid === citizenshipLookupObject.lookup_uid}))"
            />
          </v-col>
        </v-row>

        <v-row 
          v-show="loadedSystemSetting && citizenshipLookupObject && citizenshipLookupObject.value!==systemBasedCountry"
          class="dense-row"
        >
          <v-col 
            cols="12" 
            class="py-0"
            md="6"
          >
            <v-text-field
              v-model="passportNumber"
              v-validate="citizenshipLookupObject && citizenshipLookupObject.value!==systemBasedCountry ? 'required': ''"
              :disabled="!citizenshipLookupObject"
              :filled="!citizenshipLookupObject"
              :error-messages="errors.collect('passportNumber')"
              data-vv-name="passportNumber"
              data-vv-as="passport number"
              label="Passport Number"
              @input="icValidation('passport')"
            />
          </v-col>
          <v-col 
            cols="12" 
            class="py-0"
            md="3"
          >
            <v-menu
              id="passportIssueDate"
              v-model="passportIssueDateStartMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="passportIssueDateDisplay"
                  v-validate="citizenshipLookupObject && citizenshipLookupObject.value!=systemBasedCountry ? 'required' : ''"
                  :error-messages="errors.collect('passportIssueDate')"
                  data-vv-name="passportIssueDate"
                  data-vv-as="passport issue date"
                  :disabled="!citizenshipLookupObject"
                  :filled="!citizenshipLookupObject"
                  label="Passport Issue Date"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="passportIssueDate"
                class="datepicker"
                no-title
                @input="passportIssueDateStartMenu = false"
              />
            </v-menu>
          </v-col>

          <v-col 
            cols="12" 
            class="py-0"
            md="3"
          >
            <v-menu
              id="passportExpiryDate"
              v-model="passportExpiryDateStartMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="passportExpiryDateDisplay"
                  v-validate="citizenshipLookupObject && citizenshipLookupObject.value!==systemBasedCountry ? 'required' : ''"
                  :error-messages="errors.collect('passportExpiryDate')"
                  data-vv-name="passportExpiryDate"
                  data-vv-as="passport expiry date"
                  :disabled="!citizenshipLookupObject"
                  :filled="!citizenshipLookupObject"
                  label="Passport Expiry Date"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="passportExpiryDate"
                class="datepicker"
                no-title
                @input="passportExpiryDateStartMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>

        <v-row
          class="dense-row"
        >
          <v-col 
            v-if="citizenshipLookupObject && citizenshipLookupObject.value==systemBasedCountry"
            cols="12" 
            class="py-0"
            md="6"
          >
            <v-text-field
              v-model="form.ic_number"
              v-validate="citizenshipLookupObject && citizenshipLookupObject.value==systemBasedCountry ? 'required|icDate|icLength' : ''"
              v-mask="citizenshipLookupObject && citizenshipLookupObject.value==systemBasedCountry ? mask:'################################'"
              :disabled="!citizenshipLookupObject || (existed || personWithoutEmployee()) || isDraftEmpDisabled"
              :filled="!citizenshipLookupObject || isDraftEmpDisabled"
              :error-messages="errors.collect('identity.ic_number')"
              data-vv-name="identity.ic_number"
              data-vv-as="ic number"
              label="IC Number"
              @input="getBirthdayFromIC(form.ic_number);icValidation(form.ic_number);checkICFilled(form.ic_number)"
            />
          </v-col>
          <v-col 
            cols="12" 
            class="py-0"
            md="6"
          >
            <v-text-field            
              v-model="form.name"
              v-validate="'required|max:80|nameAllowedFormat'"
              :disabled="!checkIc || (existed || personWithoutEmployee())"
              :filled="!checkIc || existed"
              :error-messages="errors.collect('form.name')"
              data-vv-name="form.name"
              data-vv-as="name"
              label="Name"
              @input="form.name = form.name.toUpperCase()"
            />
          </v-col>         
        </v-row>

        <div>
          <v-row
            class="dense-row"
          >
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.title"
                v-validate="'required'"
                :disabled="!checkIc"
                :error-messages="errors.collect('person.title_lookup_uid')"
                :items="title"
                :filled="!checkIc"
                data-vv-name="person.title_lookup_uid"     
                data-vv-as="title"            
                item-text="value"
                item-value="lookup_uid"
                label="Title"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.gender"
                v-validate="'required'"
                :error-messages="errors.collect('person.gender_lookup_uid')"
                :items="gender"
                :filled="!checkIc || !newPerson"
                data-vv-name="person.gender_lookup_uid"
                data-vv-as="gender"
                item-text="value"
                item-value="lookup_uid"
                label="Gender"
              />
            </v-col>
          </v-row>

          <v-row 
            class="dense-row"
          >
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.ethnicity"
                v-validate="'required'"
                :error-messages="errors.collect('person.ethnicity_lookup_uid')"
                :items="ethnicity"
                :disabled="!checkIc"
                :filled="!checkIc"
                data-vv-name="person.ethnicity_lookup_uid"
                data-vv-as="ethnicity"
                :item-text="item => item.type !== 'ethnicity' ? item.description2 : item.value"
                item-value="lookup_uid"
                label="Ethnicity"
              />
            </v-col>    
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.religion"
                v-validate="'required'"
                :error-messages="errors.collect('person.religion_lookup_uid')"
                :items="religion"
                :disabled="!checkIc"
                :filled="!checkIc"
                data-vv-name="person.religion_lookup_uid"
                data-vv-as="religion"
                item-text="value"
                item-value="lookup_uid"
                label="Religion"
              />
            </v-col>
          </v-row>

          <v-row 
            class="dense-row"
          >
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-menu
                v-model="datepicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
                :disabled="citizenshipLookupObject && citizenshipLookupObject.value==systemBasedCountry"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-validate="'required'"
                    :error-messages="errors.collect('person.dob')"
                    data-vv-name="person.dob"
                    data-vv-as="birthday"
                    :value="displayDate"
                    label="Birthday"
                    prepend-inner-icon="event"
                    readonly
                    :filled="citizenshipLookupObject && citizenshipLookupObject.value==systemBasedCountry"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="form.birthday"
                  class="datepicker"
                  no-title
                  :disabled="citizenshipLookupObject && citizenshipLookupObject.value==systemBasedCountry"
                  @input="datepicker = false"
                />
              </v-menu>
            </v-col>
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.place_of_birth"
                v-validate="'required'"
                :error-messages="errors.collect('person.dob_state_lookup_uid')"
                :items="place_of_birth"
                :disabled="!checkIc"
                :filled="!checkIc"
                data-vv-name="person.dob_state_lookup_uid"
                data-vv-as="place of birth"         
                :item-text="item => item.type !== 'place_of_birth' ? item.description1 : item.value"
                item-value="lookup_uid"
                label="Place of Birth"
              />
            </v-col>
          </v-row>
        </div>

        <v-row 
          class="dense-row"
        >
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-autocomplete
              v-model="form.marital_status"
              v-validate="'required'"
              :error-messages="errors.collect('person.marital_status_lookup_uid')"
              :items="marital_status"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="person.marital_status_lookup_uid"   
              data-vv-as="marital status"
              item-text="value"
              item-value="lookup_uid"
              label="Marital Status"
              return-object
            />
          </v-col>

          <v-col
            md="6"
            class="py-0"
          >
            <v-menu
              id="marriageDate"
              v-model="marriageDateStartMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="marriageDateDisplay"
                  v-validate="form.marital_status && form.marital_status.value === 'Married' ? 'required' : ''"
                  :disabled="form.marital_status && form.marital_status.value !== 'Married' || !checkIc"
                  :filled="form.marital_status && form.marital_status.value !== 'Married' || !checkIc"
                  :error-messages="errors.collect('marriageDate')"
                  data-vv-name="marriageDate"
                  data-vv-as="marriage date"
                  label="Marriage Date"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="marriageDate"
                class="datepicker"
                no-title
                :max="today"
                @input="marriageDateStartMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>

        <v-row 
          class="dense-row"
        >
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="phoneNumber"
              v-validate="'phoneLength'"
              v-mask="['###-########']"
              :error-messages="errors.collect('phoneNumber')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="phoneNumber"
              label="Correspondence Phone No."
            />
          </v-col>

          <v-col
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="handphoneNumber"
              v-validate="'phoneLength'"
              v-mask="['###-########']"
              :error-messages="errors.collect('handphoneNumber')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="handphoneNumber"
              label="Handphone No."
            />         
          </v-col>
        </v-row>

        <v-row 
          class="dense-row"
        >
          <v-col
            md="6"
            class="py-0"
          >
            <v-text-field            
              v-model="email"
              v-validate="'email'"
              :disabled="!checkIc"
              :filled="!checkIc"
              :error-messages="errors.collect('email')"
              data-vv-name="company email"
              label="Company Email"
            />    
          </v-col>

          <v-col
            md="6"
            class="py-0"
          >
            <v-text-field            
              v-model="personalEmail"
              v-validate="'email'"
              :disabled="!checkIc"
              :filled="!checkIc"
              :error-messages="errors.collect('personalEmail')"
              data-vv-name="personal email"
              label="Personal Email"
            />    
          </v-col>
        </v-row>

        <v-row 
          class="dense-row"
        >
          <v-col
            cols="12"
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="addressLine1"
              v-validate="'required'"
              :error-messages="errors.collect('addressLine1')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="addressLine1"
              data-vv-as="address line  1"
              label="Correspondence Address 1"
              @input="addressLine1 = addressLine1.toUpperCase()"
            />
            <v-text-field
              v-model="addressLine2"
              :error-messages="errors.collect('addressLine2')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="addressLine2"
              label="Correspondence Address 2"
              @input="addressLine2 = addressLine2.toUpperCase()"
            />
            <v-text-field
              v-model="addressLine3"
              :error-messages="errors.collect('addressLine3')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="addressLine3"
              label="Correspondence Address 3"
              @input="addressLine3 = addressLine3.toUpperCase()"
            />
            <v-row>
              <v-col
                cols="6"
                class="py-0 pr-1"
              >
                <v-autocomplete
                  v-model="postcode"
                  v-validate="'required'"
                  :items="postcodes"
                  :error-messages="errors.collect('postcodeId')"
                  :disabled="!checkIc || !addressLine1"
                  :filled="!checkIc"
                  data-vv-name="postcodeId"
                  data-vv-as="postcode" 
                  item-text="postcode"
                  item-value="postcode"
                  value="postcode"
                  label="Postcode"
                  hide-selected
                  @input="postCodeOnChanged(postcode)"
                />
              </v-col>
              <v-col
                cols="6"
                class="py-0"
              >
                <v-autocomplete
                  v-show="postcode"
                  v-model="cityId"
                  v-validate="'required'"
                  :items="filteredCities"
                  :error-messages="errors.collect('cityId')"
                  :filled="!checkIc"
                  :disabled="dropdownDisabled"
                  data-vv-name="cityId"
                  data-vv-as="city"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="City"
                  hide-selected
                  @input="cityOnChanged(cityId)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="6"
                class="py-0 pr-1"
              >
                <v-autocomplete
                  v-show="cityId"
                  v-model="stateId"
                  v-validate="'required'"
                  disabled
                  :items="states"
                  :error-messages="errors.collect('stateId')"
                  :filled="!checkIc"
                  data-vv-name="stateId"
                  data-vv-as="state"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="State"
                  hide-selected
                />
              </v-col>
              <v-col
                cols="6"
                class="py-0"
              >
                <v-autocomplete
                  v-show="stateId"
                  v-model="countryId"
                  v-validate="'required'"
                  disabled
                  :items="countries"
                  :error-messages="errors.collect('countryId')"
                  :filled="!checkIc"
                  data-vv-name="countryId"
                  data-vv-as="country"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Country"
                  hide-selected
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-autocomplete
              v-model="department"
              v-validate="'required'"
              :error-messages="errors.collect('department_id')"
              :items="departments"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="department_id"
              data-vv-as="department"   
              item-text="name"
              item-value="id"
              value="id"
              label="Department"
            />
            <v-autocomplete
              v-model="section"
              v-validate="filteredSections && filteredSections.length > 0 ? 'required' : ''"
              :error-messages="errors.collect('section_id')"
              :items="filteredSections"
              :disabled="!checkIc || !department"
              :filled="!checkIc"
              data-vv-name="section_id"
              data-vv-as="section"   
              item-text="name"
              item-value="id"
              value="id"
              label="Section"
            />
            <v-autocomplete
              v-model="position"
              v-validate="'required'"
              :items="positions"
              :error-messages="errors.collect('position')"
              data-vv-name="position"
              label="Position"
              item-text="label"
              item-value="id"
              hide-no-data
              hide-selected
              return-object
              :disabled="!checkIc"
              :filled="!checkIc"
              @input="probationPeriodDisplay(position)"
            />
            <v-menu
              id="date"
              v-model="startmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="joinDateDisplay"
                  :disabled="!checkIc"
                  :filled="!checkIc"
                  label="Join Date"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="joinDate"
                class="datepicker"
                no-title
                :max="today"
                @input="startmenu = false"
              />
            </v-menu>
            <v-autocomplete
              v-model="probationPeriod"
              :items="probationPeriods"
              :error-messages="errors.collect('probationPeriod')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="probationPeriod"
              data-vv-as="probation period"
              item-text="name"
              item-value="id"
              value="id"
              label="Probation Period"
            />
          </v-col>
        </v-row>
        
        <v-row 
          v-show="loadedSystemSetting && citizenshipLookupObject && citizenshipLookupObject.value!==systemBasedCountry"
          class="dense-row"
        >
          <v-col 
            cols="6"
            class="py-0"
          >
            <v-text-field
              v-model="workPermitNumber"
              v-validate="citizenshipLookupObject && citizenshipLookupObject.value!==systemBasedCountry ? 'required' : ''"
              :error-messages="errors.collect('workPermitNumber')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="workPermitNumber"
              data-vv-as="work permit number"
              label="Work Permit No."
            />
          </v-col>
          <v-col 
            cols="3"
            class="py-0 pr-1"
          >
            <v-menu
              id="workPermitApprovedDate"
              v-model="workPermitApprovedDateStartMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="workPermitApprovedDateDisplay"
                  v-validate="workPermitNumber ? 'required' : ''"
                  :error-messages="errors.collect('workPermitApprovedDateDisplay')"
                  data-vv-name="workPermitApprovedDateDisplay"
                  data-vv-as="working permit approved date"
                  :disabled="!checkIc"
                  :filled="!checkIc"
                  label="Work Permit Approved Date"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="workPermitApprovedDate"
                class="datepicker"
                no-title
                @input="workPermitApprovedDateStartMenu = false"
              />
            </v-menu>
          </v-col>
          <v-col 
            cols="3"
            class="py-0"
          >
            <v-menu
              id="workPermitExpiryDate"
              v-model="workPermitExpiryDateStartMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="workPermitExpiryDateDisplay"
                  v-validate="workPermitNumber ? 'required' : ''"
                  :error-messages="errors.collect('workPermitExpiryDateDisplay')"
                  data-vv-name="workPermitExpiryDateDisplay"
                  data-vv-as="working permit expiry date"
                  :disabled="!checkIc"
                  :filled="!checkIc"
                  label="Work Permit Expiry Date"
                  prepend-inner-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="workPermitExpiryDate"
                class="datepicker"
                no-title
                @input="workPermitExpiryDateStartMenu = false"
              />
            </v-menu>
          </v-col> 
        </v-row>

        <v-row
          class="dense-row"
        >
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-autocomplete
              v-model="state"
              v-validate="'required'"
              :items="states"
              :error-messages="errors.collect('state')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="state"
              data-vv-as="state of work"
              item-text="name"
              item-value="id"
              value="id"
              label="State of Work"
              hide-selected
            />
          </v-col>
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-autocomplete
              v-show="state"
              v-model="city"
              v-validate="state ? 'required' : ''"
              :items="cityList"
              :error-messages="errors.collect('city')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="city"
              data-vv-as="city of work" 
              item-text="name"
              item-value="id"
              value="id"
              label="City of Work"
              hide-selected
            />
          </v-col>
        </v-row>

        <v-row
          class="dense-row"
        >
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-autocomplete
              v-model="workSessionType"
              v-validate="'required'"
              :items="workSessionTypes"
              :error-messages="errors.collect('workDays')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="workDays"
              data-vv-as="work day"
              item-text="name"
              item-value="id"
              value="id"
              label="Work Days"
              hide-selected
              @change="workDaysDisplay"
            />
          </v-col>
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="form.dependents"
              v-validate="'required|dependentsValue'"
              :error-messages="errors.collect('dependents')"
              :disabled="!checkIc"
              :filled="!checkIc"
              data-vv-name="dependents"
              type="number"
              label="Dependents"
              @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
            />
          </v-col>
        </v-row>

        <v-row 
          v-show="workSessionType"
          class="dense-row"
        >
          <v-col>
            <div class="font-weight-black">
              <span> Workday Session </span>
              <v-radio-group
                v-model="defaultSet"
                :disabled="!checkIc"
                :error-messages="errors.collect('workday')"
                data-vv-name="workday"
                data-vv-as="workday session template"
              >
                <v-radio
                  label="Default"
                  :value="true"
                />
                <v-radio
                  label="Customized"
                  :value="false"
                />
              </v-radio-group>
            </div>
          </v-col>
        </v-row>

        <v-row 
          v-show="workSessionType"
          class="dense-row"
        >
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Monday Session"
              disabled
              :value="formSession.monSession"
              :filled="!checkIc"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.monLeaveSession"
              :items="leaveSessions"
              :disabled="defaultSet"
              :filled="!checkIc"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.monIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Tuesday Session"
              disabled
              :value="formSession.tueSession"
              :filled="!checkIc"
            />
          </v-col>
          <v-col
            cols="12"
            class="py-0" 
            md="2"
          >
            <v-autocomplete
              v-model="formSession.tueLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.tueIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Wednesday Session"
              disabled
              :value="formSession.wedSession"
              :filled="!checkIc"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.wedLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.wedIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Thursday Session"
              disabled
              :value="formSession.thuSession"
              :filled="!checkIc"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.thuLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.thuIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Friday Session"
              disabled
              :value="formSession.friSession"
              :filled="!checkIc"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.friLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.friIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Saturday Session"
              disabled
              :value="formSession.satSession"
              :filled="!checkIc"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.satLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.satIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Sunday Session"
              disabled
              :value="formSession.sunSession"
              :filled="!checkIc"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.sunLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.sunIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-card-actions>
      <v-spacer />
      <v-btn 
        :disabled="progressing || draftProgressing"
        text
        @click="closeDialog"
      >
        Cancel
      </v-btn>
      <v-btn
        :disabled="!checkIc || progressing || contactAdmin"
        :loading="draftProgressing"
        color="hrissecondary"
        class="white--text"
        @click="checkValidation('saveAsDraft')"
      >
        Save
      </v-btn>      
      <v-btn
        :disabled="!checkIc || draftProgressing || contactAdmin"
        :loading="progressing"
        color="hrissecondary"
        class="white--text"
        @click="checkValidation('goNext')"
      >
        Next
      </v-btn>
    </v-card-actions>    
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      employee: {
        type: Object,
        default: null,
      }, 
    },
    data () {
      return {
        systemBasedCountry: '',
        leaveSessions: [],
        checkIc: false,
        contactAdmin: false,
        defaultSet: true,
        loadedSystemSetting: false,
        existed: false,
        mask: '######-##-####',
        progressing: false,
        today: new Date().toISOString().slice(0, 10), 
        // positions
        positions: [],
        position: null,
        // employee
        city: '',
        cities: [],
        department: null,
        departments: [],
        section: '',
        sections: [],
        joinDate: this.$moment().format('YYYY-MM-DD'),     
        newEmployee: false,
        startmenu: false,
        state: '',
        states: [],
        workSessionTypes: [],
        workSessionType: '',
        workPermitNumber: '',
        workPermitApprovedDateStartMenu: false,
        workPermitApprovedDate: null,
        workPermitExpiryDateStartMenu: false,
        workPermitExpiryDate: null,
        email: null,
        // person
        citizenshipLookupObject: null,
        passportNumber: null,
        passportIssueDateStartMenu: false,
        passportIssueDate: null,
        passportExpiryDateStartMenu: false,
        passportExpiryDate: null,
        marriageDateStartMenu: false,
        marriageDate: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        postcode: null,
        postcodes: [],
        cityId: null,
        stateId: null,
        countryId: null,
        countries: [],
        datepicker: false,
        existedPerson: {},
        phoneNumber: null,
        handphoneNumber: null,
        personalEmail: null,
        form: {
          title: null,
          gender: '',
          name: '',
          ethnicity: null,
          ic_number: '',
          religion: null,        
          marital_status: null,
          place_of_birth: null,
          birthday: '',
          dependents: 0,
        },
        newPerson: false,
        formSession: {
          monSession: '',
          tueSession: '',
          wedSession: '',
          thuSession: '',
          friSession: '',
          satSession: '',
          sunSession: '',

          monLeaveSession: 1,
          tueLeaveSession: 1,
          wedLeaveSession: 1,
          thuLeaveSession: 1,
          friLeaveSession: 1,
          satLeaveSession: 4,
          sunLeaveSession: 1,

          monIsPayrollFullday: 1,
          tueIsPayrollFullday: 1,
          wedIsPayrollFullday: 1,
          thuIsPayrollFullday: 1,
          friIsPayrollFullday: 1,
          satIsPayrollFullday: 1,
          sunIsPayrollFullday: 0,
        },
        probationPeriod: null,
        probationPeriods: [
          { id: 1, value: 3, name: '3 Months' },
          { id: 2, value: 6, name: '6 Months' },
        ],
        dropdownDisabled: null,
        cityIds: [],
        draftProgressing: false,
        isDraftEmpDisabled: false,
        employeeNumber: null,
        systemSettingValue: 0,
      }
    },
    computed: {
      ...mapState('lookup', ['title', 'gender', 'ethnicity', 'religion', 'marital_status', 'place_of_birth', 'citizenship']),
      cityList () {
        return this.cities.filter(city => {
          if (this.state) {
            return city.state_id === this.state
          }
          return city
        })
      },
      displayDate () {
        return this.form.birthday ? this.$moment(this.form.birthday).format('D MMM YYYY') : ''
      },
      joinDateDisplay () {
        return this.joinDate ? this.$moment(this.joinDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      marriageDateDisplay () {
        return this.marriageDate && (this.form.marital_status && this.form.marital_status.value === 'Married') ? this.$moment(this.marriageDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      passportIssueDateDisplay () {
        return this.passportIssueDate ? this.$moment(this.passportIssueDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      passportExpiryDateDisplay () {
        return this.passportExpiryDate ? this.$moment(this.passportExpiryDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      workPermitApprovedDateDisplay () {
        return this.workPermitApprovedDate ? this.$moment(this.workPermitApprovedDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      workPermitExpiryDateDisplay () {
        return this.workPermitExpiryDate ? this.$moment(this.workPermitExpiryDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      selectedWorkSessionType () {
        if (!this.workSessionType) return
        return this.workSessionTypes.find(workSessionType => { return workSessionType.id === this.workSessionType })
      },
      filteredSections () {
        if (!this.department) return
        return this.sections.filter(section => { return section.department_id === this.department })
      },
      filteredCities () {
        return this.cities.filter(city => {
          return this.cityIds.includes(city.id)
        })         
      },
    },
    watch: {
      citizenshipLookupObject: {
        immediate: true,
        handler (value) {
          if (value) {
            this.loadPostcode()
            this.loadCity()
            this.loadDepartment()
            this.loadSection()
            this.loadState()
            this.loadCountry()
            this.loadWorkSessionType()
            this.loadLeaveSession()
            this.loadPosition()
            this.loadSystemSettings()
          }
        },
      },
    },
    created () {
      let scope = this

      this.$validator.extend('icDate', {
        getMessage (field, args) {
          return 'Invalid IC Date'        
        },
        validate (value, args) {
          return scope.isValidDate(value) 
        },
      })
      this.$validator.extend('icLength', {
        getMessage (field, args) {
          return 'IC not in right length'        
        },
        validate (value, args) {
          return value.toString().length === 12
        },
      })
      this.$validator.extend('nameAllowedFormat', {
        getMessage (field, args) {
          return "Invalid name format. Only alphabet and special character of @ ' * - / . allowed for name"     
        },
        validate (value, args) {
          const regex = /^[ A-Za-z'@./*-]*$/
          return regex.test(value)
        },
      })
      this.$validator.extend('dependentsValue', {
        getMessage (field, args) {
          return 'Invalid Number of Dependents'
        },
        validate (value, args) {
          return scope.isValidDependents(value)
        },
      })
      this.$validator.extend('phoneLength', {
        getMessage (field, args) {
          return 'Invalid phone number (at least 9 numbers and max 11)'
        },
        validate (value, args) {
          return value.toString().length >= 10 && value.toString().length <= 12
        },
      })
      this.setCitizenshipLookupObject('MY')
    },
    methods: {
      resetData () {
        this.setCitizenshipLookupObject('MY')
        this.position = null
        this.city = ''
        this.department = null
        this.section = ''
        this.joinDate = this.$moment().format('YYYY-MM-DD')
        this.newEmployee = false
        this.startmenu = false
        this.state = ''
        this.personalEmail = null
        this.email = null
        this.workSessionType = ''
        this.workPermitNumber = ''
        this.workPermitApprovedDateStartMenu = false
        this.workPermitApprovedDate = null
        this.workPermitExpiryDateStartMenu = false
        this.workPermitExpiryDate = null
        this.passportNumber = null
        this.passportIssueDateStartMenu = false
        this.passportIssueDate = null
        this.passportExpiryDateStartMenu = false
        this.passportExpiryDate = null
        this.marriageDateStartMenu = false
        this.marriageDate = null
        this.addressLine1 = null
        this.addressLine2 = null
        this.addressLine3 = null
        this.postcode = null
        this.cityId = null
        this.stateId = null
        this.countryId = null
        this.phoneNumber = null
        this.handphoneNumber = null
        this.datepicker = false
        this.existedPerson = {}
        this.form.title = null
        this.form.gender = ''
        this.form.name = ''
        this.form.ethnicity = null
        this.form.ic_number = ''
        this.form.religion = null
        this.form.marital_status = null
        this.form.place_of_birth = null
        this.form.birthday = ''
        this.form.dependents = 0
        this.newPerson = false
        this.formSession.monSession = ''
        this.formSession.tueSession = ''
        this.formSession.wedSession = ''
        this.formSession.thuSession = ''
        this.formSession.friSession = ''
        this.formSession.satSession = ''
        this.formSession.sunSession = ''
        this.formSession.monLeaveSession = 1
        this.formSession.tueLeaveSession = 1
        this.formSession.wedLeaveSession = 1
        this.formSession.thuLeaveSession = 1
        this.formSession.friLeaveSession = 1
        this.formSession.satLeaveSession = 4
        this.formSession.sunLeaveSession = 1
        this.formSession.monIsPayrollFullday = 1
        this.formSession.tueIsPayrollFullday = 1
        this.formSession.wedIsPayrollFullday = 1
        this.formSession.thuIsPayrollFullday = 1
        this.formSession.friIsPayrollFullday = 1
        this.formSession.satIsPayrollFullday = 1
        this.formSession.sunIsPayrollFullday = 0
        this.loadedSystemSetting = false
        this.probationPeriod = null
        this.checkIc = false
        this.dropdownDisabled = null
        this.cityIds = []
        this.draftProgressing = false
        this.isDraftEmpDisabled = false
        this.contactAdmin = false

        this.$validator.reset()
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
      checkValidation (type) {
        if (this.citizenshipLookupObject && this.citizenshipLookupObject.value !== this.systemBasedCountry) {
          this.$validator.validate('passportNumber').then((result) => {
            if (!result) return this.$scrollToFirstErrorInput()
            this.$validator.validate('passportIssueDate').then((result) => {
              if (!result) return this.$scrollToFirstErrorInput()
              this.$validator.validate('passportExpiryDate').then((result) => {
                if (!result) return this.$scrollToFirstErrorInput()
                this.$validator.validate('form.name').then((result) => {
                  if (!result) return this.$scrollToFirstErrorInput()
                  this.$validator.validate('position').then((result) => {
                    if (!result) return this.$scrollToFirstErrorInput()

                    if (this.state) {
                      this.$validator.validate('city').then((result) => {
                        if (!result) return this.$scrollToFirstErrorInput()

                        if (type === 'saveAsDraft') {
                          this.draftProgressing = true
                          this.$emit('save-as-draft')
                        } else {
                          this.$emit('next-step')
                        }
                      })
                    } else {
                      if (type === 'saveAsDraft') {
                        this.draftProgressing = true
                        this.$emit('save-as-draft')
                      } else {
                        this.$emit('next-step')
                      }
                    }
                  })
                })
              })
            })
          })
        } else {
          this.$validator.validate('identity.ic_number').then((result) => {
            if (!result) return this.$scrollToFirstErrorInput()
            this.$validator.validate('form.name').then((result) => {
              if (!result) return this.$scrollToFirstErrorInput()
              this.$validator.validate('position').then((result) => {
                if (!result) return this.$scrollToFirstErrorInput()

                if (this.state) {
                  this.$validator.validate('city').then((result) => {
                    if (!result) return this.$scrollToFirstErrorInput()
                    
                    if (type === 'saveAsDraft') {
                      this.draftProgressing = true
                      this.$emit('save-as-draft')
                    } else {
                      this.$emit('next-step')
                    }
                  })
                } else {
                  if (type === 'saveAsDraft') {
                    this.draftProgressing = true
                    this.$emit('save-as-draft')
                  } else {
                    this.$emit('next-step')
                  }
                }
              })         
            })
          })
        }
      },
      postCodeOnChanged (postcodeValue) {
        this.cityId = null
        this.stateId = null

        var cityID = this.postcodes.filter(p => {
          return p.postcode === postcodeValue
        })  

        this.cityIds = this.cities.filter(city =>
          cityID.some(city2 => city2.city_id === city.id)
        ).map(city3 => city3.id)

        if (this.cityIds.length > 1) {
          this.dropdownDisabled = false
        } else {
          this.dropdownDisabled = true

          if (this.cityIds.length === 1) {
            const cityId = this.cityIds[0]
            const cityObject = this.getCity(cityId)
            if (cityObject) {
              this.cityId = cityObject.id
              const stateObject = this.getState(cityObject.state_id)
              if (stateObject) {
                this.stateId = stateObject.id
                const countryObject = this.getCountry(stateObject.country_id)
                this.countryId = countryObject.id
              }
            }
          }       
        }
      },
      cityOnChanged (cityId) {
        var cityObject = this.getCity(cityId)
        if (cityObject) {
          var stateObject = this.getState(cityObject.state_id)

          if (stateObject) {
            this.stateId = stateObject.id
            var countryObject = this.getCountry(stateObject.country_id)
            this.countryId = countryObject.id
          }
        }
      },
      employeeFormData () {
        return {
          city_id: this.city,
          department_id: this.department,
          joined_date: this.joinDate,
          person_uid: this.existedPerson.person_uid,
          email: this.email,
          employee_number: this.employeeNumber,
          work_permit_number: this.workPermitNumber ? this.workPermitNumber : null,
          work_permit_approved_date: this.workPermitApprovedDate ? this.workPermitApprovedDate : null,
          work_permit_expiry_date: this.workPermitExpiryDate ? this.workPermitExpiryDate : null,
          section_id: this.section,
          position_id: this.position ? this.position.id : null,
          probation_period: this.probationPeriod === 1 ? 3 : 6,
          person: {
            name: this.form.name,
            gender_lookup_uid: this.form.gender,
            address_line_1: this.addressLine1,
            address_line_2: this.addressLine2,
            address_line_3: this.addressLine3,
            citizenship_lookup_uid: this.citizenshipLookupObject.lookup_uid,
            postcode: this.postcode ? this.postcode : null,
            city_id: this.cityId ? this.cityId : null,
            state_id: this.stateId ? this.stateId : null,
            country_id: this.countryId ? this.countryId : null,
            marital_status: this.form.marital_status ? this.form.marital_status : null,
            marriage_date: this.form.marital_status && this.form.marital_status.value === 'Married' ? this.marriageDate : null,
            phone_number: this.phoneNumber,
            handphone_number: this.handphoneNumber,
            title_lookup_uid: this.form.title,
            dob: this.form.birthday ? this.$moment(this.form.birthday).format('YYYY-MM-DD HH:mm:ss') : null,
            dob_state_lookup_uid: this.form.place_of_birth,
            ethnicity_lookup_uid: this.form.ethnicity,
            religion_lookup_uid: this.form.religion,
            personal_email_address: this.personalEmail,
            no_of_dependent: this.form.dependents,
          },
          workdays: this.selectedWorkSessionType ? this.prepareWorkdayForm() : [],
          systemBasedCountry: this.systemBasedCountry,
        }
      },     
      hasEmployee () {
        this.setProgressing(true)
        this.existed = false
        this.contactAdmin = false

        this.$api.employees().show(this.existedPerson.person_uid)
          .then((res) => {
            if (res.data.status === 'complete') {
              this.contactAdmin = true
            } else {
              this.newEmployee = true
              this.checkIc = true
              this.isDraftEmpDisabled = true
              
              this.form.name = res.data.person.name
              if (res.data.person.title_lookup_uid) {
                this.form.title = res.data.person.title_lookup_uid
              }
              this.employeeNumber = res.data.employee_number
              this.form.gender = res.data.person.gender_lookup_uid
              if (res.data.city) {
                this.city = res.data.city.id
                this.state = res.data.city.state.id
              }
              this.form.dependents = res.data.person.no_of_dependent
              this.phoneNumber = res.data.person.phone_number
              this.handphoneNumber = res.data.person.handphone_number
              this.personalEmail = res.data.person.personal_email_address
              this.email = res.data.email
              this.position = res.data.current_position.position
              this.probationPeriodDisplay(res.data.current_position.position)
              this.joinDate = res.data.joined_date
              this.department = res.data.department_id
              this.form.ethnicity = res.data.person.ethnicity_lookup_uid
              this.form.religion = res.data.person.religion_lookup_uid
              if (res.data.person.marriage_date) {
                this.marriageDate = res.data.person.marriage_date
              }
              this.form.place_of_birth = res.data.person.dob_state_lookup_uid
              this.form.birthday = res.data.person.dob
              if (res.data.person.postcode) {
                this.postcode = res.data.person.postcode
                this.postCodeOnChanged(res.data.person.postcode)
                if (res.data.person.city_id) {
                  this.cityOnChanged(res.data.person.city_id)
                }
              }
              this.addressLine1 = res.data.person.address_line_1
              this.addressLine2 = res.data.person.address_line_2
              this.addressLine3 = res.data.person.address_line_3
              if (res.data.work_days.length > 0) {
                this.workSessionType = res.data.work_days[0].work_session.work_session_type_id
                this.formSession.monSession = this.$moment(res.data.work_days[0].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(res.data.work_days[0].work_session.end_time, 'hh:mm').format('hh:mm A')
                this.formSession.tueSession = this.$moment(res.data.work_days[1].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(res.data.work_days[1].work_session.end_time, 'hh:mm').format('hh:mm A')
                this.formSession.wedSession = this.$moment(res.data.work_days[2].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(res.data.work_days[2].work_session.end_time, 'hh:mm').format('hh:mm A')
                this.formSession.thuSession = this.$moment(res.data.work_days[3].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(res.data.work_days[3].work_session.end_time, 'hh:mm').format('hh:mm A')
                this.formSession.friSession = this.$moment(res.data.work_days[4].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(res.data.work_days[4].work_session.end_time, 'hh:mm').format('hh:mm A')
                this.formSession.satSession = this.$moment(res.data.work_days[5].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(res.data.work_days[5].work_session.end_time, 'hh:mm').format('hh:mm A')
                this.formSession.sunSession = this.$moment(res.data.work_days[6].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(res.data.work_days[6].work_session.end_time, 'hh:mm').format('hh:mm A')
              }
              if (res.data.person.marital_status_lookup_uid) {
                this.form.marital_status = this.getMaritalStatus(res.data.person.marital_status_lookup_uid)
              }
            }
          })
          .catch(() => {
            if (this.systemSettingValue === '1') {
              this.$api.employees().checkWorkspaceEmployee(this.existedPerson.person_uid)
                .then(response => {
                  this.form.name = this.existedPerson.name
                  this.contactAdmin = true
                  this.newEmployee = false
                }).catch((e) => {
                  this.setExistedPersonForm()
                })
            } else {
              this.setExistedPersonForm()
            }
          })
          .then(() => {
            this.setProgressing(false)
          })
      },
      setExistedPersonForm () {
        this.form.name = this.existedPerson.name
        this.form.title = this.existedPerson.title_lookup_uid
        this.form.gender = this.existedPerson.gender_lookup_uid ? this.existedPerson.gender_lookup_uid : this.form.gender
        this.form.ethnicity = this.existedPerson.ethnicity_lookup_uid
        this.form.religion = this.existedPerson.religion_lookup_uid
        this.form.marital_status = this.getMaritalStatus(this.existedPerson.marital_status_lookup_uid)
        this.form.dependents = this.existedPerson.no_of_dependent
        this.form.place_of_birth = this.existedPerson.dob_state_lookup_uid
        this.newEmployee = true
        this.checkIc = true
      },
      icValidation (value) {
        if (this.citizenshipLookupObject && this.citizenshipLookupObject.value === this.systemBasedCountry && value.toString().length === 14) {
          this.form.ic_number = this.form.ic_number.replace(/-/g, '')
          this.$validator.validate('identity.ic_number', this.form.ic_number)
            .then(result => {
              if (!result) return
              this.$api.identityCards().showPerson(this.form.ic_number)
                .then((res) => {
                  this.checkIc = true
                  this.existedPerson = res.data
                  this.existed = true
                  this.newPerson = false
                  this.newEmployee = false
                })
                .catch(() => {
                  this.checkIc = true
                  this.newPerson = true
                  this.newEmployee = true
                })
            })
        } else if (value === 'passport') {
          this.checkIc = true
          this.newPerson = true
          this.newEmployee = true
        } else {
          // this.$resetData()
        }
      },
      checkICFilled (value) {
        this.contactAdmin = false
        this.form.name = ''
        this.$validator.reset()
        
        if (value.toString().length === 12) {
          this.form.gender = value.slice(-1) % 2 === 1 
            ? '1c661585-dbe1-11e7-ba92-509a4c2dfbad' // male
            : '1c66161e-dbe1-11e7-ba92-509a4c2dfbad' // female
        } else {
          this.form.gender = null
        }
      },
      loadSystemSettings () {
        this.$api.systemSettings().list()
          .then((res) => {
            this.systemSettingValue = res.data.find(setting => 
              setting.key === 'KATIMAS_WORKSPACE_INTEGRATION'
            ).value

            this.systemBasedCountry = 'MY'
            this.loadedSystemSetting = true
          })
          .catch(() => {})
      },
      loadPostcode () {
        this.$api.postcodes().list()
          .then((res) => {
            this.postcodes = res.data
          })
          .catch(() => {})
      },
      loadCity () {
        this.$api.cities().list()
          .then((res) => {
            this.cities = res.data
          })
          .catch(() => {})
      },
      loadDepartment () {
        this.$api.hrisDepartments().list(['name'], false)
          .then((res) => {
            this.departments = res.data
          })
          .catch(() => {})
      },
      loadSection () {
        this.$api.hrisSections().list(['name'], false)
          .then((res) => {
            this.sections = res.data
          })
          .catch(() => {})
      },
      loadState () {
        this.$api.states().list()
          .then((res) => {
            this.states = res.data
          })
          .catch(() => {})
      },
      loadCountry () {
        this.$api.countries().list()
          .then((res) => {
            this.countries = res.data
          })
          .catch(() => {})
      },
      loadWorkSessionType () {
        this.$api.workSessionTypes().list('?filter[is_active]=true')
          .then((res) => {
            this.workSessionTypes = res.data
          })
          .catch(() => {})
      },
      loadLeaveSession () {
        this.$api.leaveSessions().list()
          .then((res) => {
            this.leaveSessions = res.data

            res.data.forEach(item => {
              if (item.name === 'None') {
                item.name = 'No Restriction'
              } else if (item.name === 'A.M') {
                item.name = 'A.M only'
              } else if (item.name === 'P.M') {
                item.name = 'P.M only'
              } else {
                item.name = 'Full Day'
              }
            })
          })
          .catch(() => {})
      },
      loadPosition () {
        this.$api.positions().list()
          .then((res) => {
            this.positions = res.data.map(pos => ({
              id: pos.id,
              label: `${pos.name} (${pos.job_grade.name} ${pos.job_grade.job_group.name})`,
            }))
          })
      },
      getFormData () {
        return {
          joined_date: this.joinDate,
          department_id: this.department,
          section_id: this.section,
          city_id: this.city,
          state_id: this.state,
          employee_number: 0,
          work_permit_number: this.workPermitNumber,
          work_permit_approved_date: this.workPermitApprovedDate,
          work_permit_expiry_date: this.workPermitExpiryDate,
          email: this.email,
          position_id: this.position ? this.position.id : null,
          person: {
            title_lookup_uid: this.form.title,
            gender_lookup_uid: this.form.gender,
            name: this.form.name,
            ethnicity_lookup_uid: this.form.ethnicity,
            religion_lookup_uid: this.form.religion,
            marital_status: this.form.marital_status ? this.form.marital_status : null,
            dob_state_lookup_uid: this.form.place_of_birth,
            dob: this.form.birthday ? this.$moment(this.form.birthday).format('YYYY-MM-DD HH:mm:ss') : null,
            citizenship_lookup_uid: this.citizenshipLookupObject.lookup_uid,
            address_line_1: this.addressLine1,
            address_line_2: this.addressLine2,
            address_line_3: this.addressLine3,
            postcode: this.postcode,
            city_id: this.cityId,
            state_id: this.stateId,
            country_id: this.countryId,
            marriage_date: this.form.marital_status && this.form.marital_status.value === 'Married' ? this.marriageDate : null,
            phone_number: this.phoneNumber,
            handphone_number: this.handphoneNumber,            
            personal_email_address: this.personalEmail,
            no_of_dependent: this.form.dependents,
          },
          identity: {
            ic_number: this.form.ic_number,
            passport_issue_date: this.passportIssueDate,
            passport_expiry_date: this.passportExpiryDate,
            passport_number: this.passportNumber,
          },
          workdays: this.selectedWorkSessionType ? this.prepareWorkdayForm() : [],
          probation_period: this.probationPeriod === 1 ? 3 : 6,
          systemBasedCountry: this.systemBasedCountry,
        }
      },
      prepareWorkdayForm () {
        return [
          {
            day: 1,
            work_session_id: this.selectedWorkSessionType.work_sessions[0].id,
            leave_session_id: this.formSession.monLeaveSession,
            is_payroll_fullday: this.formSession.monIsPayrollFullday,
          },
          {
            day: 2,
            work_session_id: this.selectedWorkSessionType.work_sessions[1].id,
            leave_session_id: this.formSession.tueLeaveSession,
            is_payroll_fullday: this.formSession.tueIsPayrollFullday,
          },
          {
            day: 3,
            work_session_id: this.selectedWorkSessionType.work_sessions[2].id,
            leave_session_id: this.formSession.wedLeaveSession,
            is_payroll_fullday: this.formSession.wedIsPayrollFullday,
          },
          {
            day: 4,
            work_session_id: this.selectedWorkSessionType.work_sessions[3].id,
            leave_session_id: this.formSession.thuLeaveSession,
            is_payroll_fullday: this.formSession.thuIsPayrollFullday,
          },
          {
            day: 5,
            work_session_id: this.selectedWorkSessionType.work_sessions[4].id,
            leave_session_id: this.formSession.friLeaveSession,
            is_payroll_fullday: this.formSession.friIsPayrollFullday,
          },
          {
            day: 6,
            work_session_id: this.selectedWorkSessionType.work_sessions[5].id,
            leave_session_id: this.formSession.satLeaveSession,
            is_payroll_fullday: this.formSession.satIsPayrollFullday,
          },
          {
            day: 7,
            work_session_id: this.selectedWorkSessionType.work_sessions[6].id,
            leave_session_id: this.formSession.sunLeaveSession,
            is_payroll_fullday: this.formSession.sunIsPayrollFullday,
          },
        ]
      },
      personWithoutEmployee () {
        if (!this.newPerson && this.newEmployee) { return true } else { return false }
      },
      getBirthdayFromIC (value) {
        if ((this.citizenshipLookupObject && this.citizenshipLookupObject.value === this.systemBasedCountry) && (value !== null || value !== '')) {
          if (this.isValidDate(value)) {
            var date = value.substr(0, 6)
            if (Number(date.substr(0, 2)) >= 48) {
              this.form.birthday = new Date('19' + date.substr(0, 2) + '-' + date.substr(2, 2) + '-' + date.substr(4, 2))
            } else {
              let dob = new Date('20' + date.substr(0, 2) + '-' + date.substr(2, 2) + '-' + date.substr(4, 2))
              let inFuture = new Date() < dob
              while (inFuture) {
                dob.setFullYear(dob.getFullYear() - 100)
                inFuture = new Date() < dob
              }
              this.form.birthday = dob
            }
          } else {
            this.form.birthday = null
          }
        } else {
          this.form.birthday = null
        }
      },
      isValidDate (value) {
        var y = parseInt(value.substr(0, 2))
        var m = parseInt(value.substr(2, 2))
        var d = parseInt(value.substr(4, 2))
        if (m === 0 || m > 12) { return false }
        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]
        // Adjust for leap years
        if (y % 400 === 0 || (y % 100 !== 0 && y % 4 === 0)) { monthLength[1] = 29 }
        return d > 0 && d <= monthLength[m - 1]
      },
      isValidDependents (value) {
        return value >= 0
      },
      setProgressing (status) {
        this.progressing = status
      },
      workDaysDisplay () {
        let workSession = this.workSessionTypes.find(workSessionType => { return workSessionType.id === this.selectedWorkSessionType.id })

        this.formSession.monSession = this.$moment(workSession.work_sessions[0].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[0].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.tueSession = this.$moment(workSession.work_sessions[1].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[1].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.wedSession = this.$moment(workSession.work_sessions[2].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[2].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.thuSession = this.$moment(workSession.work_sessions[3].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[3].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.friSession = this.$moment(workSession.work_sessions[4].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[4].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.satSession = this.$moment(workSession.work_sessions[5].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[5].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.sunSession = this.$moment(workSession.work_sessions[6].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[6].end_time, 'hh:mm').format('hh:mm A')
      },
      probationPeriodDisplay (position) {
        if (position.job_grade.job_category.name === 'Non Executive') {
          this.probationPeriod = 1
        } else {
          this.probationPeriod = 2
        }
      },
      citizenshipChange (citizenshipObj) {
        if (citizenshipObj.value !== 'MY') {
          let ethnicityExist = this.ethnicity.findIndex(ethnicity => ethnicity.lookup_uid === citizenshipObj.lookup_uid)
          let bornPlaceExist = this.place_of_birth.findIndex(place => place.lookup_uid === citizenshipObj.lookup_uid)
          if (ethnicityExist === -1) {
            this.ethnicity.push(citizenshipObj)
          }
          if (bornPlaceExist === -1) {
            this.place_of_birth.push(citizenshipObj)
          }
        }
      },
      getCity (cityId) {
        if (isNaN(parseInt(cityId))) return null
        return this.cities.find(city => {
          return city.id === parseInt(cityId)
        })
      },
      getState (stateId) {
        if (isNaN(parseInt(stateId))) return null
        return this.states.find(state => {
          return state.id === parseInt(stateId)
        })
      },
      getCountry (countryId) {
        if (isNaN(parseInt(countryId))) return null
        return this.countries.find(country => {
          return country.id === parseInt(countryId)
        })
      },
      getMaritalStatus (maritalStatusUid) {
        if (!this.marital_status && !maritalStatusUid) return
        return this.marital_status.find(item => item.lookup_uid === maritalStatusUid)
      },
      setCitizenshipLookupObject (citizenshipVal) {
        const matchedCitizenship = this.citizenship.find(item => item.value === citizenshipVal)
        this.citizenshipLookupObject = matchedCitizenship || null
      },
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    height:55vh;
  }
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }
  ::v-deep .theme--light.v-text-field.v-input--is-disabled>.v-input__control>.v-input__slot:before {
    border-image: none;
  }
  .dense-row {
    margin-bottom: -5px;
  }
</style>
